// extracted by mini-css-extract-plugin
module.exports = {"container":"VideoLoader_container__1WvZf","video":"VideoLoader_video__3I1QQ","normal":"VideoLoader_normal__2eBb2"};